module.exports = __webpack_public_path__ + "static/paintings-works-on-paper-thumbnail-83befb56618944c84f7268ec0e6a890b.jpg";